/* JOLI POT, avis façon carnet (assets/jp-avis.js), 23/10/2026. Utilisé par sections/jp-avis-produit.liquid, sections/jp-avis-page.liquid et sections/jp-avis-collection.liquid.
   1. Filtre par note et tri, sans rechargement (snippets/jp-avis-filtres.liquid) : pastilles « Tous, 5 à 1 cœur », clic sur une barre de l'histogramme,
      tri « Les plus récents / Les mieux notés / Les moins bien notés », compteur annoncé aux lecteurs d'écran, message si aucun avis.
      Le HTML de départ ne contient que les avis récents (SEO). 23/10/2026 (soir) : dès qu'un filtre, un tri ou « Voir plus » demande des avis absents
      de la page, on charge la liste complète (sections/jp-avis-tous.liquid via la Section Rendering API : adresse + ?section_id=jp-avis-tous,
      avis récents + archive jp_avis) et on la met à la place. Le compteur annonce le VRAI total Judge.me de la note ; jamais « 0 avis » pour une
      note qui en a ; si des avis comptés restent indisponibles, une phrase honnête l'indique (data-t-manque) ; en cas d'échec, bouton « Réessayer ».
   2. « Voir plus d'avis » : montre les suivants par paquets (data-pas), en respectant le filtre choisi.
   3. « Laisser un avis » : bouton montré seulement si le script de Judge.me est chargé (intégration d'application « Judge.me » activée dans le thème)
      et a préparé son formulaire ; le clic ouvre le formulaire natif de Judge.me. Sans Judge.me, le bouton reste masqué.
   4. 30/10/2026 (page Avis clients) : filtre « Par pot » (liste [data-jpav-produit], remplie avec la liste complète, compte par pot)
      et filtre « Par occasion » (pastilles [data-jpav-occ], adresse ?occasion=poignée de la collection) : les avis de l'occasion sont demandés
      à /collections/<poignée>?section_id=jp-avis-occasion-tous (même calcul que la page d'occasion, donc même nombre d'avis). */
(function () {
  function calme() {
    return document.documentElement.classList.contains('jp-anim-off') || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  function coeurs(k) { return k + ' cœur' + (k > 1 ? 's' : ''); }

  function equiper(sec) {
    if (sec.dataset.jpavOk) return;
    sec.dataset.jpavOk = '1';
    var outils = sec.querySelector('[data-jpav-outils]');
    var plusB = sec.querySelector('[data-jpav-plus]');
    var plusZ = plusB ? plusB.closest('.jpav__plus-zone') : null;
    var vide = sec.querySelector('[data-jpav-vide]');
    var videT = sec.querySelector('[data-jpav-vide-t]');
    var reessayer = sec.querySelector('[data-jpav-reessayer]');
    var manque = sec.querySelector('[data-jpav-manque]');
    var compteur = sec.querySelector('[data-jpav-compteur]');
    var tri = sec.querySelector('[data-jpav-tri]');
    var pas = plusB ? (parseInt(plusB.getAttribute('data-pas'), 10) || 6) : 1000;
    var url = outils ? outils.getAttribute('data-url') : '';
    var etat = { note: 0, tri: 'recent', limite: pas, p: '' };
    var choixP = sec.querySelector('[data-jpav-produit]');
    /* complet : liste complète chargée ; charge : chargement en cours ; erreur : échec du dernier chargement */
    var liste = { complet: !url, charge: false, erreur: false };

    function listes() { return Array.prototype.slice.call(sec.querySelectorAll('[data-jpav-liste]')); }
    function fiches(ul) { return Array.prototype.slice.call(ul.querySelectorAll(':scope > .jpav__fiche')); }
    function indexer() { listes().forEach(function (ul) { fiches(ul).forEach(function (li, i) { li.dataset.i = i; }); }); }
    indexer();

    /* vrais totaux Judge.me par note (pastilles), 0 = tous */
    function totalJm(k) {
      if (!outils) return -1;
      if (k) {
        var b = outils.querySelector('.jpav__pastille[data-jpav-filtre="' + k + '"]');
        var t = b ? b.getAttribute('data-total') : '';
        return (t === '' || t === null) ? -1 : (parseInt(t, 10) || 0);
      }
      var s = 0, ok = false;
      for (var i = 1; i <= 5; i++) { var x = totalJm(i); if (x >= 0) { s += x; ok = true; } }
      return ok ? s : -1;
    }
    function presents(k) {
      var n = 0;
      listes().forEach(function (ul) { fiches(ul).forEach(function (li) { if (!k || +li.dataset.note === k) n++; }); });
      return n;
    }
    function besoin() { return !liste.complet && (!!etat.p || presents(etat.note) < Math.max(totalJm(etat.note), 0)); }
    function garde(li) { return (!etat.note || +li.dataset.note === etat.note) && (!etat.p || li.dataset.p === etat.p); }
    /* liste « Par pot » : chaque pot qui a au moins un avis, avec son nombre d'avis (liste complète) */
    function remplirPots() {
      if (!choixP || !liste.complet || choixP.dataset.ok) return;
      choixP.dataset.ok = '1';
      var pots = {}, ordre = [];
      listes().forEach(function (ul) { fiches(ul).forEach(function (li) {
        var p = li.dataset.p; if (!p) return;
        if (!pots[p]) { pots[p] = { n: 0, t: li.dataset.pt || p }; ordre.push(p); }
        pots[p].n++;
      }); });
      ordre.sort(function (a, b) { return pots[b].n - pots[a].n || (pots[a].t > pots[b].t ? 1 : -1); });
      Array.prototype.slice.call(choixP.querySelectorAll('option[data-attente]')).forEach(function (o) { o.remove(); });
      ordre.forEach(function (p) {
        var o = document.createElement('option'); o.value = p; o.textContent = pots[p].t + ' (' + pots[p].n + ')'; choixP.appendChild(o);
      });
      choixP.disabled = false;
    }

    function ordonner(a, b) {
      var na = +a.dataset.note || 0, nbb = +b.dataset.note || 0;
      var da = a.dataset.date || '', db = b.dataset.date || '';
      if (etat.tri === 'haut' && na !== nbb) return nbb - na;
      if (etat.tri === 'bas' && na !== nbb) return na - nbb;
      if (da !== db) return da < db ? 1 : -1;
      return (+a.dataset.i) - (+b.dataset.i);
    }

    /* charge sections/jp-avis-tous.liquid et remplace le contenu de chaque liste par la liste complète */
    function charger() {
      if (liste.complet) return;
      if (liste.charge) { afficher(false); return; }
      liste.charge = true; liste.erreur = false;
      afficher(false);
      fetch(url, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var trouve = false;
        listes().forEach(function (ul) {
          var src = doc.querySelector('[data-jpav-liste="' + ul.getAttribute('data-jpav-liste') + '"]');
          if (!src) return;
          trouve = true;
          var frag = document.createDocumentFragment();
          Array.prototype.forEach.call(src.querySelectorAll(':scope > .jpav__fiche'), function (li) {
            var n = document.importNode(li, true); n.hidden = true; frag.appendChild(n);
          });
          ul.textContent = '';
          ul.appendChild(frag);
        });
        if (!trouve) throw new Error('vide');
        indexer();
        liste.complet = true;
        remplirPots();
      }).catch(function () {
        liste.erreur = true;
      }).then(function () {
        liste.charge = false;
        afficher(false);
      });
    }

    function afficher(focusPremierNouveau) {
      var lus = 0, reste = 0, nouveau = null;
      listes().forEach(function (ul) {
        var items = fiches(ul);
        if (outils) items.sort(ordonner).forEach(function (li) { ul.appendChild(li); });
        var vus = 0;
        items.forEach(function (li) {
          var ok = garde(li);
          if (ok) { lus++; vus++; }
          var montrer = ok && vus <= etat.limite;
          if (montrer && li.hidden && !nouveau && focusPremierNouveau) nouveau = li;
          li.hidden = !montrer;
          if (ok && !montrer) reste++;
        });
        var bloc = ul.closest('.jpav__bloc');
        if (bloc) bloc.hidden = (vus === 0);
      });
      var tot = etat.p ? lus : totalJm(etat.note);
      var vrai = Math.max(tot, lus);            /* le vrai total Judge.me (ou plus si un avis tout neuf n'est pas encore compté) */
      var aCharger = !liste.complet && !liste.erreur && lus < tot;
      if (plusZ) plusZ.hidden = !(reste > 0 || aCharger);
      if (plusB) plusB.disabled = liste.charge;
      if (compteur && outils) {
        compteur.textContent = etat.note ? (vrai + ' avis à ' + coeurs(etat.note)) : (vrai + ' avis');
        if (etat.p && choixP && choixP.selectedOptions[0]) compteur.textContent += ' sur ' + choixP.selectedOptions[0].textContent.replace(/ \(\d+\)$/, '');
        if (liste.charge) compteur.textContent += '. ' + outils.getAttribute('data-t-charge');
      }
      if (vide && outils) {
        var msg = '';
        if (liste.erreur && !liste.charge && lus < tot) msg = outils.getAttribute('data-t-erreur');
        else if (lus === 0 && (liste.charge || aCharger)) msg = outils.getAttribute('data-t-charge');
        else if (lus === 0 && etat.note && tot <= 0) msg = (outils.getAttribute('data-t-vide') || '').replace('{coeurs}', coeurs(etat.note));
        if (videT) videT.textContent = msg; else vide.textContent = msg;
        vide.hidden = !msg;
        if (reessayer) reessayer.hidden = !(msg && liste.erreur && !liste.charge);
      }
      if (manque && outils) {
        var t = '';
        if (tot > lus && liste.complet && !liste.charge) {
          t = lus > 0 ? (outils.getAttribute('data-t-manque') || '').replace('{lus}', lus).replace('{total}', tot)
            : (outils.getAttribute('data-t-manque-zero') || '').replace('{total}', tot).replace('{coeurs}', coeurs(etat.note || 5));
        }
        manque.textContent = t;
        manque.hidden = !t;
      }
      if (nouveau) { nouveau.setAttribute('tabindex', '-1'); nouveau.focus({ preventScroll: true }); }
    }

    function filtrer(k, depuisHisto) {
      etat.note = k;
      etat.limite = pas;
      sec.querySelectorAll('[data-jpav-filtre]').forEach(function (b) {
        b.setAttribute('aria-pressed', (+b.getAttribute('data-jpav-filtre') === k) ? 'true' : 'false');
      });
      if (besoin()) charger(); else afficher(false);
      /* clic sur une barre : on descend jusqu'aux avis ; le compteur (role="status") annonce le résultat */
      if (depuisHisto && outils) outils.scrollIntoView({ behavior: calme() ? 'auto' : 'smooth', block: 'start' });
    }

    if (outils) {
      outils.hidden = false;
      sec.classList.add('jpav--filtrable');
      sec.querySelectorAll('[data-jpav-filtre]').forEach(function (b) {
        b.addEventListener('click', function () {
          var k = +b.getAttribute('data-jpav-filtre') || 0;
          var histo = !!b.closest('.jpav__histo');
          if (histo && etat.note === k) k = 0; /* second clic sur la même barre : retour à tous les avis */
          filtrer(k, histo);
        });
      });
      /* trier sur une partie seulement des avis serait trompeur : on charge d'abord la liste complète */
      if (tri) tri.addEventListener('change', function () {
        etat.tri = tri.value; etat.limite = pas;
        if (!liste.complet && tri.value !== 'recent') charger(); else afficher(false);
      });
      if (reessayer) reessayer.addEventListener('click', function () { liste.erreur = false; charger(); });
    }
    if (plusB) {
      plusB.addEventListener('click', function () {
        /* avis de la note choisie encore masqués dans la page */
        var caches = 0;
        listes().forEach(function (ul) { fiches(ul).forEach(function (li) { if (li.hidden && garde(li)) caches++; }); });
        etat.limite += pas;
        /* plus assez d'avis dans la page pour remplir le paquet suivant : on charge la liste complète */
        if (caches < pas && besoin()) { liste.erreur = false; charger(); }
        else afficher(true);
      });
    }
    if (choixP) {
      choixP.addEventListener('change', function () {
        etat.p = choixP.value; etat.limite = pas;
        if (besoin()) charger(); else afficher(false);
      });
      /* la liste des pots a besoin de la liste complète : on la charge sans attendre le premier clic */
      if (!sec.classList.contains('jpav--occ')) setTimeout(function () { if (liste.complet) remplirPots(); else charger(); }, 1200);
    }
    if (outils || plusB) afficher(false);
  }

  /* 30/10/2026 : filtre « Par occasion » de la page Avis clients */
  function occasions(sec) {
    var zone = sec.querySelector('[data-jpav-occ-zone]');
    if (!zone || zone.dataset.ok) return;
    zone.dataset.ok = '1';
    var cache = {};
    function lire(h) {
      if (cache[h]) return cache[h];
      cache[h] = fetch('/collections/' + encodeURIComponent(h) + '?section_id=jp-avis-occasion-tous', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var d = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-jpav-occ-tous]');
          if (!d) throw new Error('vide');
          return d;
        });
      cache[h].catch(function () { delete cache[h]; });
      return cache[h];
    }
    var pills = Array.prototype.slice.call(zone.querySelectorAll('[data-jpav-occ]'));
    var h = '';
    try { h = new URLSearchParams(location.search).get('occasion') || ''; } catch (e) {}
    var actif = h ? zone.querySelector('[data-jpav-occ="' + (window.CSS && CSS.escape ? CSS.escape(h) : h) + '"]') : null;
    if (!actif) h = '';
    pills.forEach(function (p) { p.setAttribute('aria-pressed', (p.getAttribute('data-jpav-occ') || '') === h ? 'true' : 'false'); });
    /* la pastille choisie visible au début de la bande qu'on fait glisser */
    if (actif) { var l = actif.parentNode; l.scrollLeft = Math.max(0, actif.offsetLeft - l.offsetLeft - 8); }

    /* nombre d'avis par occasion, demandé quand la bande devient visible (3 à la fois) */
    function compter() {
      var file = pills.filter(function (p) { return p.getAttribute('data-jpav-occ'); });
      var enCours = 0;
      function suite() {
        while (enCours < 3 && file.length) {
          (function (p) {
            enCours++;
            lire(p.getAttribute('data-jpav-occ')).then(function (d) {
              var n = parseInt(d.getAttribute('data-n'), 10) || 0;
              var s = p.querySelector('[data-n]'); if (s) s.textContent = ' (' + n + ')';
              if (!n && p.getAttribute('aria-pressed') !== 'true') p.hidden = true;
            }).catch(function () {}).then(function () { enCours--; suite(); });
          })(file.shift());
        }
      }
      suite();
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (e) { if (e.some(function (x) { return x.isIntersecting; })) { io.disconnect(); compter(); } }, { rootMargin: '200px' });
      io.observe(zone);
    } else compter();

    if (!h) return;
    sec.classList.add('jpav--occ');
    var bloc = sec.querySelector('[data-jpav-occ-bloc]');
    var ul = bloc && bloc.querySelector('[data-jpav-occ-fiches]');
    var titre = bloc && bloc.querySelector('[data-jpav-occ-titre]');
    var cpt = bloc && bloc.querySelector('[data-jpav-occ-compteur]');
    var plusZ = bloc && bloc.querySelector('.jpavo__plus');
    var plusB = plusZ && plusZ.querySelector('button');
    if (!bloc || !ul) return;
    bloc.hidden = false;
    /* on arrive depuis une page d'occasion : on descend directement jusqu'aux filtres et aux avis de l'occasion */
    setTimeout(function () { zone.scrollIntoView({ block: 'start' }); }, 60);
    var nomPill = actif.firstChild ? actif.firstChild.textContent.trim() : '';
    if (titre) { var tt = titre.getAttribute('data-t') || ''; titre.textContent = tt.indexOf('{occasion}') >= 0 ? tt.replace('{occasion}', nomPill) : (tt + ' ' + nomPill).trim(); }
    if (cpt) cpt.textContent = cpt.getAttribute('data-t-charge') || '';
    var pasO = 12, montre = pasO;
    function voir() {
      var items = Array.prototype.slice.call(ul.children);
      items.forEach(function (li, i) { li.hidden = i >= montre; });
      if (plusZ) plusZ.hidden = items.length <= montre;
    }
    lire(h).then(function (d) {
      var n = parseInt(d.getAttribute('data-n'), 10) || 0;
      var frag = document.createDocumentFragment();
      Array.prototype.forEach.call(d.querySelectorAll('[data-jpav-occ-liste] > .jpav__fiche'), function (li) { frag.appendChild(document.importNode(li, true)); });
      ul.textContent = ''; ul.appendChild(frag);
      if (cpt) cpt.textContent = n + ' avis';
      voir();
    }).catch(function () {
      if (cpt) cpt.textContent = cpt.getAttribute('data-t-erreur') || '';
    });
    if (plusB) plusB.addEventListener('click', function () { montre += pasO; voir(); });
  }

  function ecrire(sec) {
    var b = sec.querySelector('[data-jpav-ecrire]');
    var zone = sec.querySelector('[data-jpav-jdgm]');
    if (!b || !zone || b.dataset.jpavOk) return;
    b.dataset.jpavOk = '1';
    var essais = 0;
    /* lien « écrire un avis » du widget Judge.me (ancien et nouveau widget) */
    function lien() {
      return zone.querySelector('.jdgm-write-rev-link, .jdgm-write-review-button, [class*="write-rev"], [class*="write-review"], [data-jdgm-write-review]');
    }
    function guetter() {
      essais++;
      if (window.jdgm && lien()) { b.hidden = false; return; }
      if (essais < 30) setTimeout(guetter, 500);
    }
    guetter();
    b.addEventListener('click', function () {
      var l = lien();
      if (!l) return;
      zone.classList.add('is-ouvert');
      l.click();
      setTimeout(function () {
        var f = zone.querySelector('.jdgm-form-wrapper, .jdgm-form, form');
        if (!f) return;
        f.scrollIntoView({ behavior: calme() ? 'auto' : 'smooth', block: 'start' });
        var champ = f.querySelector('input:not([type="hidden"]), textarea');
        if (champ) champ.focus({ preventScroll: true });
      }, 350);
    });
  }

  function tout() { document.querySelectorAll('[data-jpav]').forEach(function (s) { occasions(s); equiper(s); ecrire(s); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout); else tout();
  document.addEventListener('shopify:section:load', tout);
})();